/* eslint-disable */
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { rubikRegularBase64 } from './hebrewFont'; 
// hebrewFont.js צריך להכיל 
// export const rubikRegularBase64 = "AAEAAAASAQAABAAgR0RFRk... (base64 ארוך ללא \"data:font/ttf;base64,\")";

/**
 * columns = [{ field: 'id', headerName: 'ID' }, ...]
 * rows = [{ id: 1, name: 'User 1', ...}, ...]
 *
 * זוהי פונקציה ליצירת PDF בעברית תוך שימוש ב-jspdf ו-jspdf-autotable,
 * עם שבירת עמוד אוטומטית וכותרת עמודות שחוזרת בכל עמוד.
 */
export function handleExportPDF(columns, rows) {
  // א. מחליטים על orientation 'p' או 'l' (באופן קשיח, או אחרי מדידה)
  // כאן לשם הדוגמה בוחרים portrait:
  const orientation = 'p';

  // ב. יוצרים אובייקט jsPDF
  const doc = new jsPDF({
    orientation, // 'p' ל-portrait או 'l' ל-landscape
    unit: 'pt',  // יחידות - נקודות (points)
    format: 'a4' // גודל דף A4
  });

  // ג. מוסיפים את הגופן העברי לקובץ ה-PDF
  // 1) מוסיפים את תוכן base64 לגופן בשם \"Rubik-Regular.ttf\"
  doc.addFileToVFS('Rubik-Regular.ttf', rubikRegularBase64);

  // 2) מוסיפים הגדרה של הגופן ב-jsPDF, תחת השם \"Rubik\"
  doc.addFont('Rubik-Regular.ttf', 'Rubik', 'normal');

  // 3) מגדירים שאנחנו משתמשים בו כברירת מחדל
  doc.setFont('Rubik', 'normal');

  // ד. הכנת כותרות ושורות עבור autoTable
  // head = מערך שמכיל מערך אחד של שמות העמודות
  const head = [
    columns.map(col => col.headerName || col.field)
  ];

  // body = מערך של מערכים, כל שורה בטבלה היא מערך מחרוזות תואם לעמודות
  const body = rows.map(row =>
    columns.map(col => {
      const val = row[col.field] !== undefined ? row[col.field] : '';
      return String(val); 
    })
  );

  // ה. הפעלת autoTable לשבירת עמודים אוטומטית
  doc.autoTable({
    head,
    body,
    styles: { 
      font: 'Rubik',  // שם הגופן שהוספנו
      fontSize: 12 
    },
    headStyles: { 
      fillColor: [240, 240, 240] 
    },
    startY: 50,              // מתחילים לצייר הטבלה 50 פיקסלים מהקצה העליון
    margin: { left: 40, right: 40 },
    didDrawPage: (data) => {
      // כותרת בכל עמוד
      doc.setFontSize(14);
      doc.text('דוח בעברית - כותרת', data.settings.margin.left, 30);

      // מספר עמוד בתחתית
      const pageNum = doc.internal.getNumberOfPages();
      doc.setFontSize(10);
      doc.text(
        `עמוד ${pageNum}`,
        data.settings.margin.left, 
        doc.internal.pageSize.getHeight() - 10
      );
    }
  });

  // ו. שמירה של ה-PDF
  doc.save('hebrewTable.pdf');
}
